// helper type to define types of const notations.
export type Values<T> = T[keyof T];

export interface ETLConfigurationType {
  integration: Values<typeof ETL_INTEGRATION_TYPE>;
}

export interface ETLConfiguration extends ETLConfigurationType {
  id: number;
  configurationName: string;
  state: Values<typeof ETL_CONFIGURATION_STATUS>;
}

export const ETL_CONFIGURATION_STATUS = {
  // FE only status, visible after user logs in WXCC
  authorized: 'AUTHORIZED',
  // everything ok
  valid: 'VALID',
  // configuration is ok, but all tasks are disabled
  inactive: 'INACTIVE',
  // authorization failed on BE, user needs to log in again
  unauthorized: 'UNAUTHORIZED',
  // TODO 14. 7. 2022 (david.salamon) ->  Some other error occurred, currently only status is displayed.
  //                                      In future there needs to be message to inform user how to resolve this error state.
  error: 'ERROR',
} as const;

export const ETL_INTEGRATION_TYPE = {
  wxcc: 'wxcc',
  zoomcc: 'zoomcc',
  msteams: 'msteams',
  wxcalling: 'wxcalling',
  ucce: 'ucce',
  uccx: 'uccx',
  five9: 'five9',
  unknown: 'unknown',
} as const;

export const SUPPORTED_INTEGRATIONS = [
  ETL_INTEGRATION_TYPE.wxcc,
  ETL_INTEGRATION_TYPE.msteams,
  ETL_INTEGRATION_TYPE.wxcalling,
] as const;

export const INTEGRATIONS_WITH_ROLE_MAPPING = [ETL_INTEGRATION_TYPE.wxcc, ETL_INTEGRATION_TYPE.msteams] as const;
export const INTEGRATIONS_WITH_TEAM_SELECTOR = [ETL_INTEGRATION_TYPE.wxcalling] as const;
